export enum BaeOperationStatusEnum {
  UNKNOWN = "UNKNOWN",
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
}
